import { Component, inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar'
import { TranslateModule } from '@ngx-translate/core'
import { Observable, Subject, take } from 'rxjs'

export interface GbMultiLineSnackBarData {
  title: string
  message: string
  icon?: string
  actionLabel?: string
  color?: 'primary' | 'accent' | 'warning' | 'success' | 'neutral'
}

@Component({
  selector: 'gb-multi-line-snack-bar',
  templateUrl: './gb-multi-line-snack-bar.component.html',
  styleUrls: ['./gb-multi-line-snack-bar.component.scss'],
  imports: [MatSnackBarModule, MatButtonModule, MatIconModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class GbMultiLineSnackBarComponent implements OnInit {
  private actionSubject = new Subject<boolean>()

  snackBarRef = inject(MatSnackBarRef<GbMultiLineSnackBarComponent>)
  public data: GbMultiLineSnackBarData = inject(MAT_SNACK_BAR_DATA)

  ngOnInit(): void {
    this.snackBarRef
      .afterDismissed()
      .pipe(take(1))
      .subscribe(() => this.actionSubject.complete())
  }

  get color(): 'primary' | 'accent' | 'warning' | 'success' | 'neutral' {
    return this.data.color ?? 'accent'
  }

  action(result: boolean): void {
    this.actionSubject.next(result)
    this.snackBarRef.dismiss()
  }

  getActionObservable(): Observable<boolean> {
    return this.actionSubject.asObservable()
  }

  close(): void {
    this.snackBarRef.dismiss()
  }
}
